var _rect, _rect2, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmationPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 330,
    viewBox: "0 0 393 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 343,
    height: 284,
    rx: 26,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 343,
    height: 284,
    rx: 26,
    stroke: "#333333",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 41.5L173 159L349.5 41.5",
    stroke: "#333333",
    strokeWidth: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 313,
    cy: 250,
    r: 75,
    fill: "white",
    stroke: "#F7931A",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M313 208V253C313 255.209 314.791 257 317 257H360",
    stroke: "#F7931A",
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationPending);
export default __webpack_public_path__ + "static/media/confirmation-pending.44dbf456e2ef954aac33dc8185bfe3ca.svg";
export { ForwardRef as ReactComponent };